let accessKey;

export const setAccessKey = (access) => {
    accessKey = access;
}

export const getAccessKey = () => {
    return accessKey;
}